import React from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import cn from 'classnames';
import Delete from '../buttons/Delete';
import Settings from '../buttons/Settings/Settings';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import { getExtensionOptions, getNodeFromSelection } from '../../../../components/utils/tiptap';
import { isTouch } from '../../../../components/utils/browser';
import Convert from '../buttons/Convert';
import { EXTENSION_TYPE_NAME } from '../../constants';
const MenuButtons = ({ editor, forMobile = false })=>{
    const options = getExtensionOptions(editor, EXTENSION_TYPE_NAME);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(!forMobile && 'ds-surface-tertiary'),
        style: {
            maxWidth: '100vw',
            display: 'flex',
            flexWrap: 'wrap'
        }
    }, options.canConfigure && /*#__PURE__*/ React.createElement(Settings, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Delete, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Convert, {
        editor: editor
    }));
};
const DaDeviationThumbBubbleMenu = ({ scrollContainerRef })=>{
    const editor = useEditorContext();
    if (!editor) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : editor.isEditable) || isTouch()) {
        return null;
    }
    const nodes = getNodeFromSelection(editor);
    const open = editor.state.selection.empty === false && nodes[1] && nodes[1].type.name === EXTENSION_TYPE_NAME;
    const options = getExtensionOptions(editor, EXTENSION_TYPE_NAME);
    let buttonCount = 3;
    if (!options.canConfigure) {
        buttonCount--;
    }
    return /*#__PURE__*/ React.createElement(BlockBubbleMenu, {
        scrollContainerRef: scrollContainerRef,
        menuHeight: 38,
        menuWidth: 40 * buttonCount,
        editor: editor,
        open: open,
        childSelector: "span > span"
    }, /*#__PURE__*/ React.createElement(MenuButtons, {
        editor: editor
    }));
};
DaDeviationThumbBubbleMenu.displayName = 'DaDeviationThumbBubbleMenu';
export default DaDeviationThumbBubbleMenu;
export { MenuButtons };

//# sourceMappingURL=DaDeviationThumbBubbleMenu.js.map